import React, { useEffect, useState } from "react";
import aStyles from "./appnavbar.module.scss";
import AppNavigationAction from "./AppNavigationAction";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useLocation, useNavigate } from "react-router-dom";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";

const HOME = "Home";
const SEARCH = "Search";
const DRUG = "Drug";
const ACCOUNT = "Account";

const HOME_ROUTE = "/";
const SEARCH_ROUTE = "/app/searchLanding";
const DRUG_ROUTE = "/app/drugLanding";
const ACCOUNT_ROUTE = "/app/accountLanding";
const SEARCH_RESULTS = '/searchAction';

const determineSelectedRoute = (pathname) => {
  const isSearchSelected = pathname?.startsWith(SEARCH_ROUTE) || pathname?.startsWith(SEARCH_RESULTS);
  
  const isDrugSelected = pathname?.startsWith(DRUG_ROUTE);
  const isAccountSelected = pathname?.startsWith(ACCOUNT_ROUTE);

  const isHomeSelected = !(
    isSearchSelected ||
    isDrugSelected ||
    isAccountSelected
  );

  return {
    isHomeSelected,
    isSearchSelected,
    isDrugSelected,
    isAccountSelected,
  };
};

const AppNavigation = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { isAppMode } = useAppModernisation();
  const findInPage = useFindInPage();

  const { pathname } = location;

  const [navigationState, setNavigationState] = useState({
    isHomeSelected: false,
    isSearchSelected: false,
    isDrugSelected: false,
    isAccountSelected: false,
  });

  useEffect(() => {
    setNavigationState((prevState) => ({
      ...prevState,
      ...determineSelectedRoute(pathname),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, navigation]);

  if (isAppMode && !findInPage.isOpen) {
    return (
      <>
        <nav
          id="appNavigation"
          role="menu"
          className={aStyles.AppNavigationContainer}
        >
          <AppNavigationAction
            title={HOME}
            icon={HOME}
            isSelected={navigationState.isHomeSelected}
            to={HOME_ROUTE}
          />
          <AppNavigationAction
            title={SEARCH}
            icon={SEARCH}
            isSelected={navigationState.isSearchSelected}
            to={SEARCH_ROUTE}
          />
          <AppNavigationAction
            title={DRUG}
            icon={DRUG}
            isSelected={navigationState.isDrugSelected}
            to={DRUG_ROUTE}
          />
          <AppNavigationAction
            title={ACCOUNT}
            icon={ACCOUNT}
            isSelected={navigationState.isAccountSelected}
            to={ACCOUNT_ROUTE}
          />
        </nav>
      </>
    );
  }

  return <></>;
};

export default AppNavigation;
